


































































import { Component, Vue, Provide } from 'vue-property-decorator';
import MyNav from '@/components/nav/Index.vue'; // nav
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import {
  Button, Table, TableColumn, Message, Input, Tabs, TabPane,
} from 'element-ui';
import Decisive from '@/servers/modules/decisive/index';
// server
    @Component({
      components: {
        MyNav,
        Table,
        TableColumn,
        Button,
        Tabs,
        TabPane,
        Input,
      },
    })
export default class extends Vue {
  @Mutation public setSkeletonDescribe:any;

  @Getter public skeleton: any;

  // 左侧菜单栏
  @Getter public scaleCommonIndex: any;

  // 当前选项
  private buttonActive: number = 0;

  // 表格样式
  private tableHeaderClassName() {
    return 'table-header';
  }

  private tableRowClassName(row:any) {
    let classStr = 'table-row';
    if (row.row.ranking < 4) {
      classStr += ' rank-three';
    }
    return classStr;
  }

  // 排行图片
  private tableDataImg:any={
    1: require('@/assets/images/ui-word/rank1.png'),
    2: require('@/assets/images/ui-word/rank2.png'),
    3: require('@/assets/images/ui-word/rank3.png'),
  };

  // 进度表格
  private processData:any = [];

  // 掌握度表格
  private masteryData:any = [];

  // 我的排行
  private myRanking:any = {};

  private async created() {
    // this.setSkeletonDescribe(true);
    var that = this
    this.setSkeletonDescribe(false);
    this.title = '';// window.LS.get('vteData').course.courseTitle;
    this.$nextTick(()=>{
      that.getAllData(1);
    })
  }

  private async getAllData(type:number) {
    const data = {
      classCode: '123',
      processDefinitionId: window.LS.get('basicData').refID,
    };
    console.log(data);
    const res = await Decisive.rankingList(data);
    console.log(res);
    // 获取
    const ranking = res.data.data;
    this.processData = ranking.learningProcessRateRankingList;
    this.masteryData = ranking.masteryRateRankingList;
    this.myRanking = ranking.myRankingsInfo;
  }
}
